import { TableCell, TableHead, TableRow } from '@material-ui/core';
import taskDetailsIcon from 'screens/common/taskDetailsIcon';
import styled, { css } from 'styled-components';

const boxShadowCSS = css`
  box-shadow:
    0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 2px 6px 2px rgba(60, 64, 67, 0.149);
  outline: 0;
  z-index: 2000;
`;

const paddingCSS = css`
  ${(props) =>
    props.paddingLeft &&
    css`
      padding-left: ${props.paddingLeft};
    `};
  ${(props) =>
    props.paddingRight &&
    css`
      padding-right: ${props.paddingRight};
    `};
  // earlier by mistake we didn't use camelcase, so keeping it for backward compatibility
  ${(props) =>
    props.paddingtop &&
    css`
      padding-top: ${props.paddingtop};
    `};
  ${(props) =>
    props.paddingTop &&
    css`
      padding-top: ${props.paddingTop};
    `};
  ${(props) =>
    props.paddingBottom &&
    css`
      padding-bottom: ${props.paddingBottom};
    `};
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `};
`;

export const StyledTableHead = styled(TableHead)`
  background: ${(props) => props.theme.palette.background.paper};
  box-shadow: 1px 1px 1px #dedede;
  margin-bottom: 1rem;
`;

export const StyledTableCell = styled(TableCell)`
  position: relative;
  width: ${(props) => props.width || 'auto'};
  text-align: ${(props) => props.textAlign || 'left'};
  padding: 5px 24px 5px 16px;
  ${paddingCSS};
  border-bottom: ${(props) => (props.border ? `1px solid #EAEAEA` : 'none')};
  ${(props) =>
    props.compact &&
    css`
      padding: 0.5em 0;
      line-height: 0;
    `}
`;

export const HeaderTableCell = styled(TableCell)`
  color: ${(props) => props.theme.palette.text.secondary};
  ${paddingCSS};
  line-height: 1rem;
`;

export const StyledTaskDetailsIcon = styled(taskDetailsIcon)`
  opacity: 0;
`;

export const StyledTableRow = styled(TableRow)`
  text-decoration: ${(props) => (props.completed ? 'line-through' : 'inherit')};
  &:hover {
    ${StyledTaskDetailsIcon} {
      opacity: 100;
    }
    ${(props) =>
      props.onClick &&
      css`
        cursor: pointer;
      `}
  }
  background: ${(props) => props.theme.palette.background.paper};
  box-shadow: 1px 1px 1px #dedede;
  ${(props) =>
    props.isEditing &&
    css`
      // ${boxShadowCSS};
      td {
        border-bottom: 2px solid ${(props) => props.theme.palette.primary.main};
      }
      background: ${(props) => props.theme.palette.background.lighterBlue};
    `}
`;

export const EmployeesContainer = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.wrap &&
    css`
      flex-wrap: wrap;
    `}
  ${(props) =>
    props.unclickable &&
    css`
      pointer-events: none;
      cursor: initial;
    `}
`;
